import { Injectable } from '@angular/core';
import { WorkerTicket } from './worker-ticket.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkerAddingTicketService implements WorkerTicket {

  constructor() { }

  checkedHasChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null)
  
  public selectedEmployees?: number[] = []
  public selectedGroups?: number[] = []
  public selectedObserverEmployees?: number[] = []
  public selectedObserverGroups?: number[] = []
  public isExisting: boolean = true
  
  isEmployeeChecked(id: number): boolean {
    if(this.selectedEmployees.find(e => e == id)) return true
    return false
  }
  isEmployeeGroupeChecked(id: number): boolean {
    if(this.selectedGroups.find(e => e == id)) return true
    return false
  }
  isEmployeeObserverChecked(id: number): boolean {
    if(this.selectedObserverEmployees.find(e => e == id)) return true
    return false
  }
  public isEmployeeGroupObserverChecked(id: number): boolean {
    if(this.selectedObserverGroups.find(e => e == id)) return true
    return false
  }
  

  checkEmployee(id: number, isObserver: boolean): void {

    const isChecked: boolean = isObserver ? this.isEmployeeObserverChecked(id) : this.isEmployeeChecked(id);

    if(!isChecked){
      var newList = isObserver ? [...this.selectedObserverEmployees] : [...this.selectedEmployees]
      newList.unshift(...[id])
      isObserver ? this.selectedObserverEmployees = [...newList] : this.selectedEmployees = [...newList]
    }else {
      var newList = isObserver ? [...this.selectedObserverEmployees] : [...this.selectedEmployees]
      newList.splice(newList.indexOf(id), 1)
      isObserver ? this.selectedObserverEmployees = [...newList] : this.selectedEmployees = [...newList]
    }
    setTimeout(() =>  this.checkedHasChanged.next(true), 100)
  }
  checkEmployeeGroupe(id: number, isObserver: boolean): void {

    const isChecked: boolean = isObserver ? this.isEmployeeGroupObserverChecked(id) : this.isEmployeeGroupeChecked(id);
    if(!isChecked){
      var newList = isObserver ? [...this.selectedObserverGroups] : [...this.selectedGroups]
      newList.unshift(...[id])
      isObserver ? this.selectedObserverGroups = [...newList] : this.selectedGroups = [...newList]
    }else{
      var newList = isObserver ? [...this.selectedObserverGroups] : [...this.selectedGroups]
      newList.splice(newList.indexOf(id), 1)
      isObserver ? this.selectedObserverGroups = [...newList] : this.selectedGroups = [...newList]
    }
    setTimeout(() =>  this.checkedHasChanged.next(true), 100)
  }
}
